import React from "react";
import Hero from "../Layouts/Hero/Hero";
import Services from "../Layouts/Services/Services";
import "./Home.css";
import ITservices from "./HomeServicesItBlockCain/ITservices";
import BlockChainDevelopment from "./HomeServicesItBlockCain/BlockChainDevelopment";
import GameServices from "./HomeServicesItBlockCain/GameServices";
import Clients from "./Clinets/Clients";
import Testimonila from "../Layouts/Testimonial/Testimonila";
import ContactUs from "../Layouts/ConatctUs/ContactUs";

const Home = () => {
  return (
    <div className="home">
      <Hero />
      <div className="home_reqmaning_item">
        <Services />
        <ITservices />
        <BlockChainDevelopment />
        <GameServices />
        <Clients />
        <Testimonila />
        <ContactUs />
      </div>
    </div>
  );
};

export default Home;
